<div fxHide fxShow.lt-md>


    <div *ngIf="imageList.length==0; else imgMissing" fxLayoutAlign="center center">
      <img  src='assets/images/products/noImage/no-image.png'
        onerror="this.src='assets/images/products/noImage/no-image.png';">
    </div>
    <ng-template #imgMissing >

      <owl-carousel-o fxLayoutAlign="center center" 
      [options]="customOptions" 
      #owlCar  class="product-slick">
        <ng-container *ngFor="let  img of imageList; let l = index">
            <ng-template carouselSlide>
                <div fxLayoutAlign="center center">
                  <ng-container *ngIf="!img.includes('medicineimages')
                  &&!img.includes('http') &&!img.includes('commonimages')">
               
                    <img (click)="imagePreview(imageList , l)" 
                      [ngStyle.lt-md]="{height:productDetailHeightMobile,width:productDetailWidthMobile}"
                      [src]="img==null?assets/images/products/noImage/no-image.png:bigImage + img | safe: 'resourceUrl'"
                      onerror="this.src='assets/images/products/noImage/no-image.png';">
                  </ng-container>

                  <ng-container *ngIf="img.includes('http')">
                  
                    <img (click)="imagePreview(imageList , l)" 
                      [ngStyle.lt-md]="{height:productDetailHeightMobile,width:productDetailWidthMobile}"
                      [src]="img==null?assets/images/products/noImage/no-image.png:img| safe: 'resourceUrl'"
                      onerror="this.src='assets/images/products/noImage/no-image.png';">
                  </ng-container>
                  <ng-container *ngIf="img.includes('medicineimages')">

                  <img (click)="imagePreview(imageList , l)" 
                  [ngStyle.lt-md]="{height:productDetailHeightMobile,width:productDetailWidthMobile}"
                  [src]="img==null?assets/images/products/noImage/no-image.png:commonImageApi + img| safe: 'resourceUrl' "
                        class="img-fluid">
                  </ng-container>

                  <ng-container *ngIf="img.includes('commonimages')">

                    <img (click)="imagePreview(imageList , l)" 
                    [ngStyle.lt-md]="{height:productDetailHeightMobile,width:productDetailWidthMobile}"
                    [src]="img==null?assets/images/products/noImage/no-image.png:serverPath7 + img| safe: 'resourceUrl' "
                          class="img-fluid">
                    </ng-container>
                </div>
            </ng-template>
        </ng-container>
    </owl-carousel-o>
</ng-template>

</div>
